// src/api/userApi.ts
import axiosInstance from './axiosInstance';
import { ApiResponse, LoginPayload, RegisterPayload, User } from './types';

// src/utils/auth.ts
export const logout = () => {
  localStorage.removeItem('jwt');
};


export const loginUser = async (payload: LoginPayload): Promise<ApiResponse<User>> => {
  try {
    const res = await axiosInstance.post<{ token: string; user: User }>('/user/auth/login', payload);
    localStorage.setItem('jwt', res.data.token);

    return { data: res.data.user, error: null };
  } catch (err: any) {
    const errorMessage = err.response?.data?.message || err.message || 'Unknown error';
    return { data: null, error: errorMessage };
  }
};

export const registerUser = async (payload: RegisterPayload): Promise<ApiResponse<User>> => {
  try {
    const res = await axiosInstance.post<{ token: string; user: User }>('/user/auth/register', payload);
    localStorage.setItem('jwt', res.data.token);
    
    return { data: res.data.user, error: null };
  } catch (err: any) {
    const errorMessage = err.response?.data?.message || err.message || 'Unknown error';
    return { data: null, error: errorMessage };
  }
};

export const sendPasswordReset = async (email: string): Promise<{ success: boolean; msg?: string }> => {
  try {
    const res = await axiosInstance.post('/user/auth/request-reset', { email });
    return res.data;
  } catch (err: any) {
    return { success: false, msg: err.response?.data?.msg || 'Error sending reset email.' };
  }
};

export const sendUpdatedPasswordReset = async (email: string, token: string, newPassword: string): Promise<{ success: boolean; msg?: string }> => {
  try {
    const res = await axiosInstance.post('/user/auth/reset-password', { email, token, newPassword });
    return res.data;
  } catch (err: any) {
    return { success: false, msg: err.response?.data?.msg || 'Error reseting new password.' };
  }
};


